/* eslint-disable camelcase */
// vue set 
const baseUrl = process.env.NODE_ENV === 'production' ? './' : '/admin/' ; 

const dev = {
  showLicense:true ,
  showSideNav:true,
  showApiTitle:false,
  usePHPMenu:true,
  useDotNetMenu:false
};

const config = { 
  restApiDriver: 'phpApiUrl', // default api driver 
  dotnetApiDriver: 'dotnetApiUrl',
  baseUrl,
  pathQueryMode:'router', // get or router
  //pathQueryMode:'get', 
  clientWebUrl : 'http://172.16.3.10/',
  crStreamApiDriver : 'crStreamPhpApiUrl',
};

const defaultYearCode = {
  num: '111',
};

// restApiDriver 
const restApiDriver = {
  defaultApiUrl : 'http://172.16.3.10/AdminApi/api' ,
  dotnetApiUrl  : 'http://172.16.3.10:5080/api' ,
  phpApiUrl  : 'http://172.16.3.10/AdminApi/api' ,
  tiny_mce_wiris : 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js',
  crStreamPhpApiUrl:  'https://crstream.cloudraise.com/AdminApi/api',
};

const modulesList = {
  ssoSignIn: false,
};

const reviewExamType = {
  type: 'svg',
};

const examPaperPrintType = {
  Horizonttial: '橫式',
  Vertical: '直式',
};
const crstream = {
  id: "crsplayer",
  secret: "nYeNKWfCwbbqUGbThBFhamMZWNqqGXs4",
}

export { config, dev , restApiDriver , defaultYearCode, modulesList ,reviewExamType, examPaperPrintType, crstream};
